import {addAuthKey} from '@/helpers/addAuthKeyToUrl';

const api_url = `${process.env.VUE_APP_BASE_URL || '/'}index.php`;

function formatAddresses(list) {
    return (list || []).map((address, i) => {
        return {
            id: i,
            value: address.unrestricted_value,
        }
    });
}

export async function getAddresses(query, token) {
    const url = addAuthKey(`${api_url}/?r=api/dadata/find-address&query=${query}`, token);
    const encodedUrl = encodeURI(url);
    try {
        const response = await fetch(encodedUrl, {});
        const data = await response.json();
        if (data && data.suggestions) {
            return formatAddresses(data.suggestions);
        }
        return [];
    } catch (e) {
        console.log(e);
        return [];
    }
}
